import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { ZustandStorageKeys } from '~/constants/zustandStorageKeys';
import {
  createDismissedCreditUsageAlertSlice,
  type DismissedCreditUsageAlertSlice,
} from '~/hooks/creditUsageAlerts/createDismissedCreditUsageAlertSlice';

export const useDismissedCreditUsageAlertLocalStorageStore = create<DismissedCreditUsageAlertSlice>()(
  persist(
    (...args) => ({
      ...createDismissedCreditUsageAlertSlice()(...args),
    }),
    {
      name: ZustandStorageKeys.CreditUsageDismissedAlerts,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
